import React from 'react';
import Button from 'components/atoms/button';
import { useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import { isCcmActionAllowedStatus } from 'utils/userTypeHelper';

const ControlBtns = ({
  backBtnHandler,
  saveBtnHandler,
  saveBtnDisable,
  forwardBtnHandler,
  currentStep,
  totalSteps,
}) => {
  const patient = useSelector((state) => state.adminPanelPatients.patient);
  const canEditPage = isCcmActionAllowedStatus(patient?.profile?.ccmStatus);

  return (
    <div className="questionnaire__controls">
      <div className="questionnaire__controls-btns">
        {currentStep >= 1 && (
          <div className="questionnaire__controls-btn">
            <Button handleClick={backBtnHandler} text="< Back" fillBg={false} />
          </div>
        )}

        <div className="questionnaire__controls-btn">
          <Button
            handleClick={saveBtnHandler}
            text="Save"
            disabled={saveBtnDisable || !canEditPage}
          />
        </div>

        {currentStep < totalSteps && (
          <div className="questionnaire__controls-btn">
            <Button
              handleClick={forwardBtnHandler}
              text="Forward >"
              fillBg={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};

ControlBtns.propTypes = {
  backBtnHandler: PropTypes.func.isRequired,
  saveBtnHandler: PropTypes.func.isRequired,
  saveBtnDisable: PropTypes.bool.isRequired,
  forwardBtnHandler: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default ControlBtns;
